import { render, staticRenderFns } from "./PreCustomerList.vue?vue&type=template&id=596bec8b&scoped=true&"
import script from "./PreCustomerList.vue?vue&type=script&lang=js&"
export * from "./PreCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./PreCustomerList.vue?vue&type=style&index=0&id=596bec8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596bec8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596bec8b')) {
      api.createRecord('596bec8b', component.options)
    } else {
      api.reload('596bec8b', component.options)
    }
    module.hot.accept("./PreCustomerList.vue?vue&type=template&id=596bec8b&scoped=true&", function () {
      api.rerender('596bec8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/CustomerMgt/PreCustomerList.vue"
export default component.exports